<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/meiya_c.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>
						美亚1-6类团意险（C款）
						<!--                        <span style="color:red;">建筑行业</span>-->
					</h2>
					<div style="color: red">1-6类职业 | 最高可保100万 | 5-6类可保高空</div>
					<p>
						① 线上投保，支持月单
						<br />
						② 可扩展自费药
						<br />
						③ 3人起保，最高可保100万
						<br />
						④ 意外医疗保额为单次事故限额，无次数限制，多次事故之间无间隔期
						<br />
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 25px"
						type="text"
						@click.native="handleDownLoad">
						下载美亚团意险职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<el-row>
						<el-col :span="8">
							保障期限：
							<el-select v-model="qixian" placeholder="请选择保障期限" @change="computePrice">
								<el-option
									v-for="item in qixians"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-col>
						<el-col :span="8">
							扩展自费药方案：
							<el-select v-model="kuozhanRate" placeholder="请选择扩展方案" @change="onChangeKuozhanRate">
								<el-option
									v-for="item in kuozhanRateList"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-col>
					</el-row>

					<avue-crud
						ref="crud"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"
						:table-loading="isShowLoading"></avue-crud>
				</el-card>

				<div style="margin-top: 30px">
					<avue-crud :data="questionData" :option="questionOption" :span-method="onQuestionSpanMethod"></avue-crud>
				</div>

				<!--                <el-card>-->
				<!--                    <avue-crud ref="plan"-->
				<!--                               :span-method="spanMethodPlan"-->
				<!--                               :option="optionPlan"-->
				<!--                               :data="dataPlan">-->
				<!--                    </avue-crud>-->

				<!--                </el-card>-->
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="(qa, index) in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>

								<div style="margin-top: 10px">
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>

									<template v-if="qa.question === '投保人名称含有哪些关键字不能投保本保险？'">
										如投保人名称中包含：
										<span style="font-weight: bold">
											危险品、人力资源、拆、分包、外包、劳务派遣、幕墙、脚手架、爆破、爆炸、渔业、隧道
										</span>
										，则不能投保本保险。
									</template>
									<template v-if="qa.question === '投保本保险有哪些系统校验需要特别注意？'">
										除了
										<span style="font-weight: bold">
											投保人信息真实性校验、最低投保人数校验、被保险人年龄校验、被保险人投保份数校验
										</span>
										等常规校验需要注意之外，以下几个特殊校验也需要重点关注。
										<span style="font-weight: bold">
											《投保重要事项确认书》盖章件模板是否使用正确、是否清晰完整、是否正向上传、印章企业名称是否与投保人名称一致；切勿伪造印章投保！！！
										</span>
										投保界面录入的经办人/联系人是否存在于
										<span style="font-weight: bold">不同投保人的有效保单下；</span>
										<span style="font-weight: bold">投保人的所有有效保单</span>
										是否存在
										<span style="font-weight: bold">超过三个经办人/联系人</span>
										的情况; 如因系统校验核保未通过，请关注报错提示，进行相应调整后再次投保即可。
									</template>
									<template
										v-else-if="qa.question === '被保险人出险时的职业类别高于投保时的职业类别，理赔会打折赔付吗？'">
										如被保险人的实际职业类别高于所申请参保保险计划对应的职业类别，则发生理赔时该被保险人的实际赔付金额按以下公式计算：
										<span style="font-weight: bold">
											实际赔付金额=符合保险合同约定的赔付金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%。
										</span>
									</template>
									<template v-else-if="qa.question === '意外医疗的最长给付时间是多久？保单到期后还能保障多久？'">
										按照条款约定，若被保险人因遭遇意外事故而
										<span style="font-weight: bold">于意外事故发生日起一百八十天内</span>
										寻求合法注册的医生、护士、医院或救护车服务，则对其因此已支出的必需且合理的实际医药费用，保险公司按保险合同约定补偿该被保险人。
										即使保险合同到期，只要是属于
										<span style="font-weight: bold">意外事故发生日起一百八十天内</span>
										支出的必需且合理的实际医药费用，保险公司也会按保险合同约定补偿该被保险人。
										注：意外事故骨折后续的拆取钢板费用不受180天的限制。
									</template>
									<template v-else-if="qa.question === '起保人数是怎样要求的？'">
										<span class="red-bold">仅包含1-3类职业3人起保，包含4-6类职业需要5人起保。</span>
									</template>
									<span v-else style="white-space: pre-wrap">{{ qa.answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
						<div style="margin-top: 30px; margin-left: 40px">
							<avue-crud :data="questionData" :option="questionOption" :span-method="onQuestionSpanMethod"></avue-crud>
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>

						<p style="line-height: 28px">
							1、本保险为互联网专属产品，由美亚财产保险有限公司（以下简称“保险公司”）承保，面向全国（不含港澳台）进行销售，本保险支持在线投保、核保、保单查询和报案等服务，您可以通过“美亚保险客户服务”微信小程序线上办理退保、批改和理赔等业务。目前保险公司在上海、北京、广东省（含深圳市）、江苏省和浙江省设有分支机构。
							<span class="red-bold">
								保险公司无分支机构的地区，可能无法向您提供及时的面对面线下服务，保险公司将通过电话及互联网通道在线为您提供保单服务。如有任何疑问，可拨打保险公司客户服务热线400-820-8858。
							</span>
							<br />
							2、所有的保险责任及条款均以与保险公司正式订立保险合同的规定为准。
							<br />
							3、被保险人身故保险金受益人为被保险人的继承人。
							<br />
							4、本保险最早的生效时间为T+1零时，最晚为T+30零时（T是指投保成功日）。
							<br />
							5、投保人须获得被保险人的同意，方可为其投保本保险。
							<br />
							6、本保险的约定投保资格须同时满足以下要求：
							<br />
							<span class="red-bold">
								（1）属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。前述雇员参保时的年龄限制：18-65周岁。
							</span>
							<br />
							<span class="red-bold">为明确起见，相关定义约定如下：</span>
							<br />
							<span class="red-bold">
								1）本保险所称的投保行业不包括任何提供人力资源服务的人力资源、劳务派遣公司及其他人力资源中介。
							</span>
							<br />
							<span class="red-bold">
								2）本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，且该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期劳动用工的情形。
							</span>
							<br />
							<span class="red-bold">
								3）本保险所称的“在岗全职雇员”须在与投保人存在劳动用工关系期间，不存在除投保人之外的其他用人单位或用工主体。为避免歧义，在岗全职雇员不包括与投保人存在劳动用工关系的非全职临时工、小时工、兼职实习生等非全职雇员以及培训学员、会员等不具备劳动用工关系的人员。
							</span>
							<br />
							（2）属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。
							<br />
							如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则
							<span class="red-bold">
								保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
							</span>
							<br />
							7、
							<span class="red-bold">
								如投保人名称中包含以下关键字，则保险公司不接受该投保申请：危险品、人力资源、拆、分包、外包、劳务派遣、幕墙、脚手架、爆破、爆炸、渔业、隧道。
							</span>
							<br />
							8、保险合同成立时投保人数不低于3人。
							<span class="red-bold">如被保险人含职业类别四或职业类别五或职业类别六，则被保险人人数应不低于5人。</span>
							单张保单最高投保人数为1000人。
							<br />
							9、
							<span class="red-bold">
								保险公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总赔偿限额为限。如在任一意外事故中，前述总赔偿限额低于按每一被保险人的保险金额给付的总赔偿金额，则保险公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
							</span>
							<br />
							10、
							<span class="red-bold">每一意外事故总赔偿限额说明：</span>
							<br />
							每一意外事故总赔偿限额为以下两者较高者：
							<br />
							（1) 保险合同生效时，保险单所载单个被保险人在意外身故及伤残保障项下所适用的最高保险金额的10倍；
							<br />
							（2) 人民币500万元。
							<br />
							11、本保险所承保的被保险人的职业类别以投保时约定的为准（具体职业请以保险公司职业分类表为准）。投保人在为被保险人申请投保时，应按被保险人的实际职业类别填写，如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准。若申报的被保险人的职业类别不真实，则视为投保人故意未依法履行如实告知义务，并按照下列规定处理
							<br />

							（1）
							<span class="red-bold">
								如该被保险人的实际职业类别为申请投保时本合同约定不接受投保的职业类别，则其被保资格将被取消；对于取消其被保资格前所发生的保险事故，保险公司不承担任何保险责任。
							</span>
							除本合同另有约定外，保险公司在前述取消该被保险人被保资格的情形下将退还其项下相应的未满期保险费。
							<br />
							（2）如该被保险人的实际职业类别为申请投保时本合同约定接受投保的职业类别，但高于为其所申报保险计划对应的职业类别，则该被保险人发生保险事故后，无论该保险事故是否与职业类别相关，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%
							</span>
							<br />
							12、如任何被保险人在保险期间内职业类别发生任何变更，投保人或该被保险人应于变更后十个工作日内书面通知保险公司。保险公司收到投保人或该被保险人的通知后，有权按下列规定调整该被保险人的承保条件或拒绝接受该被保险人继续成为本合同的被保险人：
							<br />
							（1）如其变更后的职业类别相比变更前风险程度降低的，则保险公司按日比例退还自其变更职业类别之日起相应保险费的差额；
							<br />
							（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别的，投保人应按日比例补缴自该被保险人变更职业类别之日起相应保险费的差额；
							<br />
							（3）如其变更后的职业类别为本合同约定不接受投保的职业类别，则自该被保险人变更职业类别之日起，保险公司不再接受该被保险人继续成为本合同的被保险人，其被保资格将于变更职业类别之日二十四时丧失，保险公司将按承保日比例退还该被保险人未满期保险费。
							<br />
							投保人或被保险人未履行上述通知义务的，保险公司按照下列规定进行处理：
							<br />
							（1）如其变更后的职业类别为本合同约定不接受投保的职业类别，则其被保资格于变更职业类别之日二十四时丧失，对于其丧失被保资格后所发生的保险事故，保险公司不承担任何保险责任；
							<br />
							（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别，则对于该被保险人在职业类别变更后发生的保险事故，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/变更后职业类别对应的应交保险费）*70%
							</span>
							<br />
							13、每位团体成员于保险公司投保的团体意外伤害保险仅限一份，多投无效，不同计划重叠购买的无效。若任一团体成员于保险公司投保多份团体意外伤害保险或购买多份计划，则保险公司仅以首次成功投保的计划为准，并退还其它保险计划项下已收取的保险费。
							<br />
							14、同一职业类别的被保险人必须选择相同的保险计划。
							<br />
							15、本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。
							<span class="red-bold">
								若5类和6类的被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。
							</span>
							<br />
							16、被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。
							<span class="red-bold">
								若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，保险公司不承担任何保险责任。
							</span>
							特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。
							<br />
							17、
							<span class="red-bold">意外医药补偿保额说明：</span>
							<br />
							（1）若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。
							<br />
							（2）若任何被保险人拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额的105%为限，但须扣除该被保险人任何已取得的医药费用补偿。
							<br />
							18、
							<span class="red-bold">
								本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
							</span>
							<br />
							19、
							<span class="red-bold">
								本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
							</span>
							<br />
							20、
							<span class="red-bold">
								《美亚附加意外每日住院津贴团体收入保障保险》项下所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。
							</span>
							<br />
							21、本保险为团体保险，投保人不得以任何方式销售给第三方（第三方包括但不限于被保险人本人）。
							<br />
							22、
							<span class="red-bold">
								若保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
							</span>
							<br />
							23、
							<span class="red-bold">
								本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							</span>
							<br />
							24、被保险人的投保年龄以申请时被保险人的周岁年龄为准。
							<br />
							25、新增或减少被保险人的申报：保险合同有效期间，若有团体成员的新增或减少，投保人须将该新增及减少的成员资料申报至保险公司。对于新增团体成员，经保险公司确认同意承保后，该新增成员自投保人申报次日零时起获得被保资格。
							<br />
							26、保险凭证：保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。
							<br />
							27、
							<span class="red-bold">
								投保人未能披露与本保险相关之重大事实（包括但不限于是否符合本投保申请上述所有投保前提条件，下同）可能导致保险公司不承担保险责任。
							</span>
							重大事实系指可能影响保险公司风险评估或接受投保申请与否之事实。如果投保人不能确定某些事实是否属于应披露之重大事实，请予以披露。
							<br />
							28、本保险
							<span class="red-bold">仅提供电子版本的保险单</span>
							，根据预留的电子邮件地址发送电子版本的保险单，投保人可登录
							<el-link href="https://www-401.aiginsurance.com.cn/CIRC/accident_policy_enquiry.asp" type="primary">
								美亚保险信息自主查询系统
							</el-link>
							进行保单验真。
							<br />
							29、本保险适用条款：
							<br />
							（1）
							<span class="red-bold">通用条款：</span>
							《美亚附加被保险人资格条款（2022年第一版）》《美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）》《美亚附加被保险人职业类别处理规则条款（2022年第一版）》《美亚附加不承保特定医院条款（2022年第一版）》《美亚附加短期保险费条款（2022年第一版）》《美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）》《美亚附加经济制裁责任免除条款》《美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）》《美亚附加特种作业限制条款（2021年第二版）（互联网专属）》《美亚团体意外伤害保险（2021年第一版）（互联网专属）》《美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）》《美亚附加争议处理条款（2023年第一版）》
							<br />
							（2）
							<span class="red-bold">意外医药补偿保障适用条款：</span>
							<br />
							如投保的意外医药补偿保障仅限医保范围内的医疗费用，不承保全额自费费用，则适用《美亚附加意外医药补偿团体医疗保险（2022年第三版）（互联网专属）》；
							<br />
							如投保的意外医药补偿保障不限医保范围内的医疗费用，保障全额自费费用，则适用《美亚附加意外医药补偿团体医疗保险（2021年第三版）（互联网专属）》
							<br />
							30、
							<span class="red-bold">重要提示：</span>
							<br />
							（1）请仔细阅读本保险所有投保前提条件，确认符合所列投保前提条件方可进行投保。
							<br />
							（2）为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，
							<span class="red-bold">尤其是免除保险人责任的规定</span>
							。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
							<br />
							（3）本投保申请、保险条款、保险单、批单或批注（如有）及其它约定书均为保险合同的构成部分。
							<br />
							（4）为了维护您的利益，投保人/被保险人需详细并如实填写投保申请上所列资料。
							<br />
							（5）美亚财产保险有限公司综合偿付能力充足率达到监管要求，且风险综合评级提示操作、战略、声誉和流动风险较小，具体偿付能力指标和风险综合评级结果请查询公司官方网站
							<el-link href="www.aig.com.cn" type="primary">www.aig.com.cn</el-link>
							。
							<br />
							保险合同项下应付保险费含适用的增值税。
							<br />
						</p>

						<el-divider></el-divider>
						<h3>重要提示</h3>
						<p style="line-height: 32px">
							1、投保人须获得被保险人的同意，方可为其投保本保险。
							<br />
							2、本保险为团体保险，投保人不得以任何方式销售给第三方(第三方包括但不限于被保险人本人)。
							<br />
							3、保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。
							<br />
							4、
							<span class="red-bold">
								任何已提出投保申请的人员或在保险期间内可能提出参保申请的人员，均须符合本保险约定的投保资格。如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
							</span>
							<br />
							5、本保险所承保的被保险人的职业类别以投保时约定的为准（具体职业请以保险公司职业分类表为准）。投保人在为被保险人申请投保时，应按被保险人的实际职业类别填写，如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准。若
							<span class="red-bold">
								申报的被保险人的职业类别不真实，则视为投保人故意未依法履行如实告知义务，并按照下列规定处理：
							</span>
							<br />
							<span class="red-bold">
								(1)
								如该被保险人的实际职业类别为申请投保时本合同约定不接受投保的职业类别，则其被保资格将被取消；对于取消其被保资格前所发生的保险事故，保险公司不承担任何保险责任。除本合同另有约定外，保险公司在前述取消该被保险人被保资格的情形下将退还其项下相应的未满期保险费。
							</span>
							<br />
							<span class="red-bold">
								(2)
								如该被保险人的实际职业类别为申请投保时本合同约定接受投保的职业类别，但高于为其所申报保险计划对应的职业类别，则该被保险人发生保险事故后，无论该保险事故是否与职业类别相关，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							</span>
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%。
							</span>
							<br />
							6、如任何被保险人在保险期间内职业类别发生任何变更，投保人或该被保险人应于变更后十个工作日内书面通知保险公司。保险公司收到投保人或该被保险人的通知后，有权按下列规定调整该被保险人的承保条件或拒绝接受该被保险人继续成为本合同的被保险人：
							<br />
							（1）如其变更后的职业类别相比变更前风险程度降低的，则保险公司按日比例退还自其变更职业类别之日起相应保险费的差额；
							<br />
							（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别的，投保人应按日比例补缴自该被保险人变更职业类别之日起相应保险费的差额；
							<br />
							（3）如其变更后的职业类别为本合同约定不接受投保的职业类别，则自该被保险人变更职业类别之日起，保险公司不再接受该被保险人继续成为本合同的被保险人，其被保资格将于变更职业类别之日二十四时丧失，保险公司将按承保日比例退还该被保险人未满期保险费。
							<br />
							<span class="red-bold">
								投保人或被保险人未履行上述通知义务的，保险公司按照下列规定进行处理：
								<br />
								（1）如其变更后的职业类别为本合同约定不接受投保的职业类别，则其被保资格于变更职业类别之日二十四时丧失，对于其丧失被保资格后所发生的保险事故，保险公司不承担任何保险责任；
								<br />
								（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别，则对于该被保险人在职业类别变更后发生的保险事故，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							</span>
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/变更后职业类别对应的应交保险费）*70%。
							</span>
							<br />
							7、
							<span class="red-bold">被保险人的身故保险金受益人为被保险人的继承人。</span>
							<br />
							8、
							<span class="red-bold">
								本公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总暗偿限额为限。如在任一意外事故中，前述总赔偿限额低干按每一被保险人的保险金额给付的总赔偿金额，则本公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
							</span>
							<br />
							9、若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则本公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。
							<br />
							若任何被保险人
							<span class="red-bold">
								拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，
							</span>
							则本公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应
							<span class="red-bold">
								保险金额的百分之一百零五(105%)为限，但须扣除该被保险人任何已取得的医药费用补偿。
							</span>
							<br />
							10、
							<span class="red-bold">
								本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T
								3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。若5类和6类的被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。
							</span>
							<br />
							11、
							<span class="red-bold">
								被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。特种作业证书以国家(特种作业人员安全技术培训考核管理规定》规定的为准。
							</span>
							<br />
							12、
							<span class="red-bold">
								本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
							</span>
							<br />
							13、
							<span class="red-bold">
								本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上(含二级)公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
							</span>
							<br />
							14、
							<span class="red-bold">
								《美亚附加意外每日住院津贴团体收入保障保险》项下所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。
							</span>
							<br />
							15、
							<span class="red-bold">
								本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							</span>
							<br />
							16、
							<span class="red-bold">
								若本保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致本保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则本保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
							</span>
							<br />
							17、本保险单与投保申请、保险条款、批单或批注（如有）及其它约定书均为保险合同的构成部分。
							<br />
							18、为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，
							<span class="red-bold">尤其是免除保险人责任的规定</span>
							。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
							<br />
							19、为了保障您的利益，请在收到本保险单一周内拨打我公司服务热线4008208858核实保险单资料，包括保险单所列示的销售人员或销售中介机构信息。
							<br />
							20、保险合同项下应付保险费含适用的增值税。
							<br />
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="下载" name="3">
				<avue-crud ref="crud_content" :data="listDatas" :option="option">
					<template slot="menu" slot-scope="{row}">
						<el-button icon="el-icon-download" type="text" @click="onDownload(row)">下载</el-button>
					</template>
				</avue-crud>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile, handleDownCustom} from '@/util/util'
import {getProductPrice} from '@/api/insurance/product'
import {optionPlanMyC} from '@/const/crud/insurance/productDetail'

export default {
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data() {
		return {
			currentStep: '0',
			isShowLoading: false,
			qixian: 12,
			qixians: [
				{
					value: 12,
					label: '12个月',
				},
				{
					value: 11,
					label: '11个月',
				},
				{
					value: 10,
					label: '10个月',
				},
				{
					value: 9,
					label: '9个月',
				},
				{
					value: 8,
					label: '8个月',
				},
				{
					value: 7,
					label: '7个月',
				},
				{
					value: 6,
					label: '6个月',
				},
				{
					value: 5,
					label: '5个月',
				},
				{
					value: 4,
					label: '4个月',
				},
				{
					value: 3,
					label: '3个月',
				},
				{
					value: 2,
					label: '2个月',
				},
				{
					value: 1,
					label: '1个月',
				},
			],
			kuozhanRate: 304,
			kuozhanRateList: [
				{
					label: '否',
					value: 304,
				},
				{
					label: '是',
					value: 305,
				},
			],
			optionPlan: optionPlanMyC,
			dataPlan: [
				{
					insuredItem: '意外身故及伤残保障',
					plan1: '100000',
					plan2: '200000',
					plan3: '300000',
					plan4: '400000',
					plan5: '500000',
					plan6: '600000',
					plan7: '700000',
					plan8: '800000',
					plan9: '900000',
					plan10: '1000000',
				},
				{
					insuredItem:
						'意外医药补偿（每次意外事故限额)' +
						'（中国大陆境内医药费用仅限当地社保规定个人自负部分）' +
						'（含救护车费用年度累计限额RMB1,000）',
					plan1: '10000',
					plan2: '20000',
					plan3: '30000',
					plan4: '40000',
					plan5: '50000',
					plan6: '60000',
					plan7: '70000',
					plan8: '80000',
					plan9: '90000',
					plan10: '100000',
				},
				{
					insuredItem: '每次事故免赔额',
					plan1: '100',
				},
				{
					insuredItem: '每次事故赔付比例',
					plan1:
						'理赔时从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿的，赔付比例100%；理赔时未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿的，赔付比例80%',
				},
				{
					insuredItem: '意外每日住院津贴（每一保险年度总赔偿日数以180天为限）',
					plan1: '100/天',
				},
				{
					insuredItem: '每次住院免责天数',
					plan1: '3天',
				},
			],
			currentMonth: 12,
			priceYearCurrent: [],
			priceYearTemp: [
				{
					insuredItem: '职业类别一',
					scope: 27,
				},
				{
					insuredItem: '职业类别二',
					scope: 28,
				},
				{
					insuredItem: '职业类别三',
					scope: 29,
				},
				{
					insuredItem: '职业类别四',
					scope: 30,
				},
				{
					insuredItem: '职业类别五',
					scope: 31,
				},
				{
					insuredItem: '职业类别六',
					scope: 32,
				},
			],
			dataQA: [
				{
					question: '保障范围是怎样的？',
					answer: '本保险仅承担被保险人在中国大陆（不含港澳台）发生保险事故导致的保险责任。',
				},
				{
					question: '对被保险人年龄限制是怎么样的？',
					answer: '被保险人投保 年龄为18-65周岁。',
				},
				{
					question: '起保人数是怎样要求的？',
					answer: '仅包含1-3类职业3人起保，包含4-6类职业需要5人起保。',
				},
				{
					question: '最早多久能生效？',
					answer: '最早的生效时间为T+1的零时，最晚为T+30的零时（T是指投保成功日）。',
				},
				{
					question: '哪些人可以投保本保险？',
					answer:
						'投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，且投保年龄为16-70周岁，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。\n' +
						'本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期雇佣的情形。\n' +
						'中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。',
				},
				{
					question: '对于被保险人的身份，必须是全职员工吗？比如以下几种情况的员工是否可以承保呢？',
					answer:
						'被保险人与投保人没有签署劳动合同或其他形式的书面用工合同，但却存在实际用工关系的员工；\n' +
						'企业雇佣的非全职临时工/小时工/兼职实习生等非全职雇员以及培训学员、会员等不具备劳动用工关系的人员；\n' +
						'投保人（例如劳务派遣公司/人力资源公司）雇佣的人员签署了劳动合同或其他形式的雇佣合同但却外派到其他公司工作，并非为投保人工作的情形；\n' +
						'劳务公司派遣到投保人企业的员工，非与投保人直接签署劳动合同或其他形式的雇佣合同。\n' +
						'被保险人与投保人需存在“直接雇佣关系”，双方有签署劳动合同或其他书面形式的用工合同，且被保险人必须为投保人的“全职职员”，因此以上四种情形的人员不可以投保。',
				},
				{
					question: '投保人名称含有哪些关键字不能投保本保险？',
					answer:
						'如投保人名称中包含：危险品、人力资源、拆、分包、外包、劳务派遣、幕墙、脚手架、爆破、爆炸、渔业、隧道，则不能投保本保险。',
				},
				{
					question: '投保本保险有哪些系统校验需要特别注意？',
					answer:
						'除了投保人信息真实性校验、最低投保人数校验、被保险人年龄校验、被保险人投保份数校验等常规校验需要注意之外，以下几个特殊校验也需要重点关注。\n' +
						'  《投保重要事项确认书》盖章件模板是否使用正确、是否清晰完整、是否正向上传、印章企业名称是否与投保人名称一致；切勿伪造印章投保！！！\n' +
						'投保界面录入的经办人/联系人是否存在于不同投保人的有效保单下；\n' +
						'投保人的所有有效保单是否存在超过三个经办人/联系人的情况;\n' +
						'    如因系统校验核保未通过，请关注报错提示，进行相应调整后再次投保即可。',
				},
				{
					question: '保全加人如何收费的？',
					answer: '不区分年/月计划，保全加人按照剩余天数收费。计算公式：计划保费*剩余保险期间天数/保单天数。',
				},
				{
					question: '本保险对替换是怎样要求的？',
					answer: '本保险没有替换率的限制，同一职业类别才能替换，不同职业类别不能替换。',
				},
				{
					question: '一个被保险人可以买几份？',
					answer: '每个被保险人限投一份',
				},
				{
					question: '同一张保单，所有被保险人需要选择相同的可选责任吗？',
					answer: '是的，要么都不选，要么都选择，且选择的可选责任要一致。',
				},
				{
					question: '意外医疗的最长给付时间是多久？保单到期后还能保障多久？',
					answer:
						'按照条款约定，若被保险人因遭遇意外事故而于意外事故发生日起一百八十天内寻求合法注册的医生、护士、医院或救护车服务，则对其因此已支出的必需且合理的实际医药费用，保险公司按保险合同约定补偿该被保险人。\n' +
						'即使保险合同到期，只要是属于意外事故发生日起一百八十天内支出的必需且合理的实际医药费用，保险公司也会按保险合同约定补偿该被保险人。\n' +
						'注：意外事故骨折后续的拆取钢板费用不受180天的限制。',
				},
				{
					question: '本保险对于医院的要求是怎样的？',
					answer:
						'本保险所称的医院必须是经国家卫生部门评审确定的二级以上（含二级）公立医院。\n' +
						'本保险所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。',
				},
				{
					question: '对特种作业证要求是怎样的？',
					answer:
						'未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保险责任。特种作业的相关定义以国家《特种作业人员安全技术培训考核管理规定》为准。',
				},
				{
					question: '对高处作业的要求是怎样的？',
					answer:
						'本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T 3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。\n' +
						'若被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。\n' +
						'对于职业类别为1至4类的被保险人，本保险不承保其任何5米及以上的高处作业。',
				},
				{
					question: '被保险人出险时的职业类别高于投保时的职业类别，理赔会打折赔付吗？',
					answer:
						'如被保险人的实际职业类别高于所申请参保保险计划对应的职业类别，则发生理赔时该被保险人的实际赔付金额按以下公式计算：\n' +
						'实际赔付金额=符合保险合同约定的赔付金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%。',
				},
			],
			isDownLoading: false,
			option: {
				card: true,
				stripe: true,
				border: true,
				align: 'center',
				menuAlign: 'center',
				gutter: 20,
				index: true,
				indexLabel: '序号',
				header: false,
				editBtn: false,
				delBtn: false,
				column: [
					{
						label: '标题',
						prop: 'title',
					},
				],
			},
			listDatas: [
				{
					title: '美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）',
					fileUrl: '/download/my/my_1.pdf',
					fileName: '美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）.pdf',
				},
				{
					title: '美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）',
					fileUrl: '/download/my/my_2.pdf',
					fileName: '美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）.pdf',
				},
				{
					title: '美亚附加特种作业限制条款（2021年第二版）（互联网专属）',
					fileUrl: '/download/my/my_3.pdf',
					fileName: '美亚附加特种作业限制条款（2021年第二版）（互联网专属）.pdf',
				},
				{
					title: '美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）',
					fileUrl: '/download/my/my_4.pdf',
					fileName: '美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）.pdf',
				},
				{
					title: '美亚附加被保险人资格条款（2022年第一版）',
					fileUrl: '/download/my/my_5.pdf',
					fileName: '美亚附加被保险人资格条款（2022年第一版）.pdf',
				},
				{
					title: '美亚附加短期保险费条款（2022年第一版）',
					fileUrl: '/download/my/my_6.pdf',
					fileName: '美亚附加短期保险费条款（2022年第一版）.pdf',
				},
				{
					title: '美亚附加不承保特定医院条款（2022年第一版）-互联网团意标准条款',
					fileUrl: '/download/my/my_7.pdf',
					fileName: '美亚附加不承保特定医院条款（2022年第一版）-互联网团意标准条款.pdf',
				},
				{
					title: '美亚附加被保险人职业类别处理规则条款（2022年第一版）-互联网团意标准条款',
					fileUrl: '/download/my/my_8.pdf',
					fileName: '美亚附加被保险人职业类别处理规则条款（2022年第一版）-互联网团意标准条款.pdf',
				},
				{
					title: '美亚团体意外伤害保险（2021年第一版）（互联网专属）',
					fileUrl: '/download/my/my_9.pdf',
					fileName: '美亚团体意外伤害保险（2021年第一版）（互联网专属）.pdf',
				},
				{
					title: '美亚附加经济制裁责任免除条款',
					fileUrl: '/download/my/my_10.pdf',
					fileName: '美亚附加经济制裁责任免除条款.pdf',
				},
				{
					title: '美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）',
					fileUrl: '/download/my/my_11.pdf',
					fileName: '美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）.pdf',
				},
				{
					title: '美亚附加意外医药补偿团体医疗保险（2022年第三版）（互联网专属）-仅限医保范围',
					fileUrl: '/download/my/my_12.pdf',
					fileName: '美亚附加意外医药补偿团体医疗保险（2022年第三版）（互联网专属）-仅限医保范围.pdf',
				},
				{
					title: '美亚附加意外医药补偿团体医疗保险（2021年第三版）（互联网专属）-不限医保范围',
					fileUrl: '/download/my/my_13.pdf',
					fileName: '美亚附加意外医药补偿团体医疗保险（2021年第三版）（互联网专属）-不限医保范围.pdf',
				},
				{
					title: '和顺保互联网团意C款_海报（无二维码）',
					fileUrl: '/download/my/my_14.jpg',
					fileName: 'A1_和顺保互联网团意C款_海报（无二维码）.jpg',
				},
				{
					title: '和顺保互联网团意_健康意外险索赔证明资料清单',
					fileUrl: '/download/my/my_15.pdf',
					fileName: '和顺保互联网团意_健康意外险索赔证明资料清单.pdf',
				},
				{
					title: '和顺保互联网团意C款_常见问题',
					fileUrl: '/download/my/my_16.docx',
					fileName: '和顺保互联网团意C款_常见问题.docx',
				},
				{
					title: '和顺保互联网团意C款_发票及理赔须知',
					fileUrl: '/download/my/my_17.docx',
					fileName: '和顺保互联网团意C款_发票及理赔须知.docx',
				},
				{
					title: '和顺保互联网团意C款_各条款保险责任描述（全）',
					fileUrl: '/download/my/my_18.docx',
					fileName: '和顺保互联网团意C款_各条款保险责任描述（全）.docx',
				},
				{
					title: '和顺保互联网团意_个人保险索赔申请表',
					fileUrl: '/download/my/my_19.pdf',
					fileName: '和顺保互联网团意_个人保险索赔申请表.pdf',
				},
				{
					title: '和顺保互联网团意C款_责任免除',
					fileUrl: '/download/my/my_20.docx',
					fileName: '和顺保互联网团意C款_责任免除.docx',
				},
				{
					title: '和顺保互联网团意C款_投保人声明及确认',
					fileUrl: '/download/my/my_21.doc',
					fileName: '和顺保互联网团意C款_投保人声明及确认.doc',
				},
				{
					title: '美亚附加争议处理条款（2023年第一版）',
					fileUrl: '/download/my/my_22.pdf',
					fileName: '美亚附加争议处理条款（2023年第一版）.pdf',
				},
			],
			questionData: [
				{
					temp1: '本保险方案的各条款保险责任描述',
					temp2: '意外身故及伤残保险金给付',
					temp3: `保险人于保险合同项下对任一被保险人给付的各项保险金累计金额以保险单所载该被保险人相应的保险金额为最高限额。 <br>（1）身故保险金：任何被保险人在保险合同有效期内遭遇意外事故，且自事故发生之日起一百八十天内直接且单独因该意外事故身故的，保险公司按保险单上所载该被保险人相应的保险金额给付身故保险金受益人。 <br>（2）意外伤残保险金：任何被保险人于保险合同有效期内遭遇意外事故，且自意外事故发生之日起一百八十天内直接且单独因该意外事故致成《人身保险伤残评定标准及代码》（保监发[2014]6号，标准编号为JR/T0083-2013，以下简称“评定标准”）中所列的伤残项目，保险公司给付意外伤残保险金予该被保险人，该给付金额为按所致伤残根据评定标准评定的伤残程度等级相对应的给付比例乘以保险单上所载该被保险人相应的保险金额计算。`,
				},
				{
					temp2: '意外医药补偿保险金给付',
					temp3: `若不扩展自费药 保险合同有效期内，若任何被保险人因遭遇意外事故而于意外事故发生日起一百八十天内寻求合法注册的医生、护士、医院或救护车服务，则对其因此已支出的必需且合理的实际医药费用（<span style="font-weight: bold">仅限医保范围内的医疗费用，不承保全额自费费用，</span><span class="red-bold">含救护车费用年度累计限额RMB1,000</span>），保险公司按下述规定补偿该被保险人。`,
					temp4: `（1）若被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则保险公司在扣除保险单所载适用于该情形下的免赔额（100元/次）后，再按保险单所载适用于该情形下的赔付比例（80%）补偿该被保险人，但最高以保险单所载该被保险人相应的保险金额为限；<br> （2）若被保险人拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，则保险公司按如下公式补偿该被保险人，但最高以保险单所载该被保险人相应的保险金额的105%为限：医药费用补偿金=[已支出的必需且合理的实际医药费用–任何获得的医药费用补偿-保险单所载适用于该情形下的免赔额（100元/次）]X保险单所载适用于该情形下的赔付比例（100%）。`,
				},
				{
					temp3:
						'若扩展自费药 保险合同有效期内，若任何被保险人因遭遇意外事故而于意外事故发生日起一百八十天内寻求合法注册的医生、护士、医院或救护车服务，则对其因此已支出的必需且合理的实际医药费用<span style="font-weight: bold">（不限医保范围内的医疗费用，保障全额自费费用）</span>，保险公司按下述规定补偿该被保险人。',
				},

				{
					temp2: '意外每日住院津贴保险金给付',
					temp3:
						'在保险合同有效期内，若任何被保险人因遭受意外事故而入住医院治疗，保险公司将依据保险单所载该被保险人所对应的意外每日住院津贴金额，按住院天数-免赔天数（3天/次）赔偿该被保险人，每一被保险人保险年度总赔偿日数以180天为限。',
				},
			],
			questionOption: {
				border: true,
				menuAlign: 'center',
				header: false,
				menu: false,
				showHeader: false,
				card: true,
				column: [
					{
						prop: 'temp1',
						width: 120,
					},
					{
						prop: 'temp2',
						width: 120,
					},
					{
						prop: 'temp3',
						html: true,
					},
					{
						prop: 'temp4',
						html: true,
					},
				],
			},
		}
	},
	created() {
		this.initData()
	},
	mounted() {
		this.setPrice()
	},
	methods: {
		//获取金额
		initData() {
			let query = {
				pid: this.kuozhanRate,
			}
			this.isShowLoading = true
			getProductPrice(query)
				.then(({data: {data = [], code = -1}}) => {
					if (code !== 0 || data.length === 0) {
						this.$message.error('获取数据有误!')
						return
					}
					let tempData = this.deepClone(this.priceYearTemp)
					tempData.forEach((itemData) => {
						let {scope = 0} = itemData
						let tempNum = 1
						for (let {scope: scopeTemp, price} of data) {
							if (scopeTemp === scope) {
								this.$set(itemData, `plan${tempNum}`, price / 100)
								tempNum++
							}
						}
					})
					this.priceYearCurrent = tempData
					this.setPrice()
				})
				.catch(() => {})
				.finally(() => {
					this.isShowLoading = false
				})
		},
		//设置金额
		setPrice() {
			let tempPercent = 0
			switch (this.currentMonth) {
				case 1:
					tempPercent = 0.2
					break
				case 2:
					tempPercent = 0.3
					break
				case 3:
					tempPercent = 0.4
					break
				case 4:
					tempPercent = 0.5
					break
				case 5:
					tempPercent = 0.6
					break
				case 6:
					tempPercent = 0.7
					break
				case 7:
					tempPercent = 0.75
					break
				case 8:
					tempPercent = 0.8
					break
				case 9:
					tempPercent = 0.85
					break
				case 10:
					tempPercent = 0.9
					break
				case 11:
					tempPercent = 0.95
					break
				case 12:
					tempPercent = 1
					break
			}
			let tempWei = `元/${this.currentMonth}月`
			let tempYearData = this.deepClone(this.priceYearCurrent)
			tempYearData.forEach((itemData) => {
				for (let i = 1; i <= 10; i++) {
					let tempVal = itemData[`plan${i}`]
					if (this.validatenull(tempVal)) {
						itemData[`plan${i}`] = '不适用'
					} else {
						itemData[`plan${i}`] = tempPercent === 1 ? tempVal + tempWei : (tempVal * tempPercent).toFixed(2) + tempWei
					}
				}
			})
			if (this.dataPlan.length > 6) {
				//添加过则
				this.dataPlan.splice(6, 6, ...tempYearData)
			} else {
				this.dataPlan.push(...tempYearData)
			}
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 2 || rowIndex === 3 || rowIndex === 4 || rowIndex === 5) {
				if (columnIndex === 1) {
					return [1, 11]
				}
			}
			// if (columnIndex === 0) {
			//     if (rowIndex >= 9) {
			//         if (columnIndex === 0) {
			//             if (rowIndex % 2 === 1) {
			//                 return {
			//                     rowspan: 2,
			//                     colspan: 1
			//                 }
			//             } else {
			//                 return {
			//                     rowspan: 0,
			//                     colspan: 0
			//                 }
			//             }
			//         }
			//     }
			// }
			// if (rowIndex < 9) {
			//     if (columnIndex === 0) {
			//         return [1, 2]
			//     } else if (columnIndex === 1) {
			//         return [0, 0]
			//     }
			// }
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `my_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		computePrice(val) {
			this.currentMonth = val
			this.setPrice()
		},
		onDownload({fileUrl, fileName}) {
			handleDownCustom(fileUrl, {}, fileName, 'get')
		},
		onChangeKuozhanRate(val) {
			//扩展方案
			this.kuozhanRate = val
			this.initData()
		},
		onQuestionSpanMethod({row, column, rowIndex, columnIndex}) {
			if ((rowIndex === 0 || rowIndex === 3) && columnIndex === 2) {
				return [1, 2]
			}

			if (columnIndex === 0) {
				if (rowIndex === 0) {
					return {
						rowspan: 4,
						colspan: 1,
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0,
					}
				}
			}
			if (columnIndex === 1 || columnIndex === 3) {
				if (rowIndex === 1) {
					return {
						rowspan: 2,
						colspan: 1,
					}
				} else if (rowIndex === 2) {
					return {
						rowspan: 0,
						colspan: 0,
					}
				}
			}
		},
	},
}
</script>

<style scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
